import {Component} from '@angular/core';
import {Location} from '@angular/common';

@Component({
    selector: 'tfl-back-button',
    template: `
        <button class="btn-link" style="text-decoration: none" (click)="goBack()">
            <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
            <span>{{'COMMON.BACK'|translate}}</span>
        </button>
    `,
    styles: [`
        span {
            vertical-align: super;
        }

        i {
            font-size: 2em;
        }
    `
    ]
})
export class BackButtonComponent {
    constructor(private location: Location) {
    }

    goBack(): void {
        this.location.back();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/back-button/back-button.ts